export const firebaseConfig = {
    apiKey: "AIzaSyDOnFvVlO7UUzaSX9zXBBr7eTXF2Z1AxW0",
    authDomain: "fir-trial-7eebb.firebaseapp.com",
    databaseURL: "https://fir-trial-7eebb.firebaseio.com",
    projectId: "fir-trial-7eebb",
    storageBucket: "fir-trial-7eebb.appspot.com",
    messagingSenderId: "402912309827"
  };